import React from 'react';
import whiteLogo from '../../Assets/img/logoArabic.svg'

const MaintainanceScreen = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <img src={whiteLogo} alt="logoWhite" style={{ width: "24em", marginTop: "4em" }} />
      <p style={{ fontSize: "20px", marginTop: "5em", textAlign: "center" }}>
        The system is currently undergoing maintainance. Please contact 16300 for any inquiries
      </p>
      <p style={{ fontSize: "20px", marginTop: "0.5em", textAlign: "center" }}>
        النظام قيد الصيانة حالياً. يرجى الاتصال على الرقم ١٦٣٠٠ لأي استفسارات.
      </p>
    </div>
  );
};

export default MaintainanceScreen;